// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const electivire: PokeData = {
  "id": 466,
  "name": "electivire",
  "height": 18,
  "weight": 1386,
  "base_experience": 243,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "fire-punch",
    "thunder-punch",
    "leer",
    "low-kick",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "screech",
    "light-screen",
    "swift",
    "spark",
    "charge",
    "shock-wave",
    "giga-impact",
    "discharge",
    "electro-ball",
    "wild-charge",
    "ion-deluge",
    "electric-terrain"
  ],
  "moves": [
    "fire-punch",
    "thunder-punch",
    "leer",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "wild-charge",
    "electric-terrain",
    "thunder-fang",
    "electric-wrath",
    "zap-cannon",
    "volt-switch"
  ],
  "evolution_chain": {
    "id": 60,
    "item": null,
    "species": [
      {
        "name": "elekid",
        "order": 145,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "electabuzz",
        "order": 146,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 239,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "electivire",
        "order": 147,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 125,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 129,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
